import i18n from "@/lang/lang"
import store from "@/store"

var rules = {
  required: value => !!value || i18n.t("Form.__Required"),
  min: value => (value != null && value.length >= 8) || "Please use at least 8 characters.",
  password: value =>
    (value != null && value.length >= 8 && value.length <= 16 && value.search(/[a-z]/) != -1 && value.search(/[A-Z]/) != -1) ||
    i18n.t("Form.__InvalidPassword"),
  otp: value => (value != null && value.length == 6) || "Please enter 6-digit code.",
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || value == "" || value == null || i18n.t("Form.__InvalidEmail")
  },
  rateRange: value => (value > 0 && value < 100) || i18n.t("Form.__InvalidRate"),
  numberAndLetters: value => {
    const pattern = /^[0-9a-zA-Z]+$/
    return pattern.test(value) || i18n.t("Form.__InvalidDisplayId")
  },
  length6to12: value => (value != null && value.length >= 6 && value.length <= 12) || i18n.t("Form.__InvalidDisplayId"),
  isNotOwnDisplayId: value => store.getters["bizes/displayId"]() != value || i18n.t("Form.__CannotAddCurrentBiz")
}

export { rules }
